import React, { useState } from 'react';
import copy from 'clipboard-copy';
import { CopySucces } from '../../CopySucces';
import { Icon } from '../../Icons';
import { Ripple } from '../../Ripple';

interface Props {
  sharedLink: string;
}
export const CopyShared = ({ sharedLink }: Props) => {
  const [copySuccess, setCopySuccess] = useState(false);

  const onClick = () => {
    setCopySuccess(true);
    copy(sharedLink);
  };
  const copyOk = () => {
    if (!copySuccess) {
      return null;
    }
    return <CopySucces />;
  };
  return (
    <Ripple>
      <li
        className="f14 abbey fw4 flex justify-between pt16 pb16 pointer hover-bg-wild-sand"
        onClick={onClick}
      >
        <span className="flex items-center">
          <Icon name="SvgIconCopy" className="mr4" height={24} width={24} />
          Copiar link
        </span>
        {copyOk()}
      </li>
    </Ripple>
  );
};
